{
    "statusCode": 200,
    "message": "consulta ok",
    "data": {
        "id": "MIN_JUSTICIA",
        "name": "Ministerio de Justicia",
        "fullName": "Ministerio de Justicia y del Derecho",
        "abbreviation": "MINJUSTICIA",
        "color": "#235087",
        "brandGov": "assets/img/brand_co_pmv.svg",
        "brandMinistry": "assets/img/justicia_full.svg",
        "brandMinistryFull": "assets/img/justicia_full.svg",
        "data": {
            "address": "Calle 53 No. 13 - 27 / Bogotá D.C, Colombia",
            "zip": "110231",
            "phone": "+57 (60) 1 444 31 00",
            "freeLine": "01 8000 911170",
            "time": "Lunes a Viernes de 8:30 a.m. a 4:30 p.m. en jornada continua.",
            "anticorrup": "601 4443100 Ext 1310",
            "emailInsti": "ministerio@minjusticia.gov.co",
            "emailCorres": "notificaciones.judiciales@minjusticia.gov.co"
        },
        "redes": {
            "facebook": {
                "path": "#",
                "user": "@MinJusticiaCo"
            },
            "x": {
                "path": "#",
                "user": "@MinJusticiaCo"
            },
            "instagram": {
                "path": "#",
                "user": "@MinJusticiaCo"
            }
        },
        "headquarters": [
            {
                "name": "Sede Centro - Dirección Despacho",
                "address": "Cra 9 No. 12C - 10",
                "phone": "+57 (60) 1 444 31 00",
                "emailInsti": "ministerio@minjusticia.gov.co",
                "time": "Lunes a Viernes de 8:30 a.m. a 4:30 p.m. en jornada continua."
            }
        ],
        "legal": {
            "policies": "#",
            "sitemaps": "#",
            "terms": "#",
            "acces": "#"
        }
    }
}